import {LogOut, Bell, User, Settings, RefreshCw} from "lucide-react";
import {useState} from "react";
import {useUserStore} from "../../store/userStore";
import service from "../../api/FetchInterceptor";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import logo from '../../assets/images/LOGO_DNC.jpeg';

export const Header = () => {
    const navigate = useNavigate();
    const { user, setUser, switchProfile } = useUserStore();

    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [switchingProfile, setSwitchingProfile] = useState(false);

    const handleSwitchProfile = async (code) => {
        if (switchingProfile || code === user.onlineProfileCode) {
            return;
        }

        setSwitchingProfile(true);

        try {
            await switchProfile(code);

            setIsDropdownOpen(false);

            window.location.reload();
        } finally {
            setSwitchingProfile(false);
        }
    };

    const logout = async () => {
        try {
            await service({
                method: "POST",
                url: "logout",
            });
        } catch (e) {
            console.warn("Logout API failed, proceeding client-side.", e);
        } finally {
            Cookies.remove("token", { path: "/" });

            if (typeof setUser === "function") setUser(null);

            setIsDropdownOpen(false);

            navigate("/login");
        }
    };


    return (
        <header className="fixed top-0 left-0 right-0 text-white p-2 z-50 bg-white border-b h-16">
            <div className="mx-4 h-full">
                <div className="flex flex-row justify-between items-center h-full">
                    <img
                        src={logo}
                        alt="Espace AC | DNC"
                        className="w-40"
                    />

                    <div className="flex items-center space-x-4">
                        <button className="p-2 hover:bg-gray-100 rounded-full">
                            <Bell className="h-5 w-5 text-gray-600"/>
                        </button>
                        <div className="relative">
                            <button
                                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                                className="flex items-center space-x-2 p-2 hover:bg-gray-100 rounded-lg"
                            >
                                <div className="bg-blue-100 p-2 rounded-full">
                                    <User className="h-5 w-5 text-blue-600"/>
                                </div>
                                <div className="text-left">
                                    <div className="font-medium text-gray-900">{user.name}</div>
                                    <div className="text-sm text-gray-500">
                                        {user.autoriteContractante || user.roles?.map((role) => role.label).join(", ")}
                                    </div>
                                </div>
                            </button>

                            {isDropdownOpen && (
                                <div
                                    className="absolute right-0 mt-2 w-72 bg-white rounded-lg shadow-lg border border-gray-200 z-50">
                                    <div className="px-4 py-3 border-b border-gray-100">
                                        <div className="flex items-center space-x-3">
                                            <div className="bg-gray-200 p-2 rounded-full">
                                                <User className="h-5 w-5 text-gray-600"/>
                                            </div>
                                            <div>
                                                <div className="font-medium text-gray-900">{user.name}</div>
                                                <div className="text-sm text-gray-500">{user.roles.map((role) => role.label).join(", ")}</div>
                                            </div>
                                        </div>
                                    </div>

                                    {user.profiles?.length > 1 && (
                                        <div className="py-2 border-b border-gray-100">
                                            <div className="px-4 pb-1 text-xs font-semibold text-gray-400 uppercase">
                                                Autorité contractante
                                            </div>

                                            {user.profiles.map((profile) => (
                                                <button
                                                    key={profile.code}
                                                    disabled={switchingProfile}
                                                    onClick={() => handleSwitchProfile(profile.code)}
                                                    className="w-full px-4 py-2 text-left hover:bg-gray-50 flex items-center space-x-3 disabled:opacity-50"
                                                >
                                                    <RefreshCw className="h-4 w-4 text-gray-500 flex-shrink-0" />
                                                    <span className={profile.code === user.onlineProfileCode ? "text-blue-600 font-medium" : "text-gray-700"}>
                                                        {profile.label || "Affectation sans libellé"}
                                                    </span>
                                                </button>
                                            ))}
                                        </div>
                                    )}

                                    <div className="py-2">
                                        <a
                                            href="/dashboard/profile"
                                            className="w-full px-4 py-2 text-left hover:bg-gray-50 flex items-center space-x-3">
                                            <Settings className="h-4 w-4 text-gray-500" />
                                            <span className="text-gray-700">Gestion du profil</span>
                                        </a>

                                        <button
                                            onClick={logout}
                                            className="w-full px-4 py-2 text-left hover:bg-gray-50 flex items-center space-x-3 text-red-600">
                                            <LogOut className="h-4 w-4" />
                                            <span>Déconnexion</span>
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </header>
    )
}